import { render, staticRenderFns } from "./SeederGenerator.vue?vue&type=template&id=6ba6c2c4"
import script from "./SeederGenerator.vue?vue&type=script&lang=js"
export * from "./SeederGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports